.shape-ui-list mat-icon{color:#232426de;font-size:18px}a.shape-ui-list{pointer-events:auto}
/*# sourceMappingURL=edit-tags-button.component.css.map */
